import component from './zh-CN/component';
import easyRecord from './zh-CN/easyRecord';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import system from './zh-CN/system';

export default {
  'app.brandName': '记录易',
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.footer.copyright': '2026 珊瑚智成（北京）科技有限公司',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.workbench.link.fetch-blocks': '获取全部区块',
  'app.workbench.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...easyRecord,
  ...system,
};
